import { useDataTableContext } from "@msuite/ui/table";
import { getServiceCalculationItemAtomicNumber } from "@msuite/utils/calculations";
import type { Calculation } from "@msuite/utils/types";
import { memo, useMemo } from "react";

/** Props Interface */
interface CalculationServiceItemAtomicNumberProps {
	item: Calculation["_serviceCalculationItems"][number];
}

function CalculationServiceItemAtomicNumberImpl({ item }: CalculationServiceItemAtomicNumberProps) {
	/** Hooks */
	const { table } = useDataTableContext();

	/** Computed */
	const rows = table?.getCoreRowModel().rows;
	const atomicNumber = useMemo(() => {
		if (!rows) return null;
		const items = rows.map(
			(row) => row.original as Calculation["_serviceCalculationItems"][number],
		);
		return getServiceCalculationItemAtomicNumber(items, item);
	}, [rows, item]);

	/** Guard */
	if (atomicNumber === null) return "000";

	/** Render */
	return atomicNumber;
}

export const CalculationServiceItemAtomicNumber = memo(CalculationServiceItemAtomicNumberImpl);
